export class CardType {
  constructor(data) {
    this.name = data.name;
    this.value = data.value;
    this.length = data.length;
    this.prefixes = data.prefixes;
  }
}

export const CARD_TYPE = {
  Visa: new CardType({
    name: 'Visa',
    value: 'Visa',
    length: '13,16',
    prefixes: '4',
  }),
  MasterCard: new CardType({
    name: 'MasterCard',
    value: 'MasterCard',
    length: '16',
    prefixes: '51,52,53,54,55',
  }),
  AmEx: new CardType({
    name: 'American Express',
    value: 'AmericanExpress',
    length: '15',
    prefixes: '34,37',
  }),
  Discover: new CardType({
    name: 'Discover',
    value: 'Discover',
    length: '16',
    prefixes: '6',
  }),
};

export const CARD_TYPES = Object.values(CARD_TYPE);
